import axios from 'axios'
const mainUrl = process.env.VUE_APP_ROOT_API

const getVideoThumb = async (link) => {
  if (link.service === 'vimeo') {
    let imageSrc = ''
    await axios.get('https://vimeo.com/api/v2/video/' + link.id + '.json').then((data) => {
      imageSrc = data.data[0].thumbnail_large
    })
    return imageSrc
  } else if (link.service === 'youtube') {
    return `https://img.youtube.com/vi/${link.id}/0.jpg`
  } else if (link.service === 'bilibili' && link.thumbnail) {
    return `${mainUrl}thumbnails/${link.thumbnail}`
  }
}

export default getVideoThumb
